import React, { Component } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import Api from "../Service/Api";
import moment from "moment";
import Review from "./Review";
import UserBookingCard from "./UserBookingCard";
import Loaders from "./FullScreenLoader";

const TABS = [
  { key: "upcoming", label: "Upcoming", listKey: "upcoming" },
  { key: "complete", label: "Completed", listKey: "complete" },
  { key: "failed", label: "Failed", listKey: "list" },
];

const EMPTY_COPY = {
  upcoming: {
    title: "No upcoming bookings",
    text: "When you book an adventure, it will show up here.",
  },
  complete: {
    title: "No completed bookings",
    text: "Tours you've finished will appear in this list.",
  },
  failed: {
    title: "No failed bookings",
    text: "Unsuccessful payment attempts will show here.",
  },
};

class UserBooking extends Component {
  state = {
    list: [],
    complete: [],
    upcoming: [],
    loading: true,
    page: 6,
    prevY: 0,
    statusB: "upcoming",
    modalShow: false,
    modalShow2: false,
    eventid: null,
    operadtorid: null,
    userId: null,
    cancelBookingId: null,
  };

  componentDidMount() {
    this.fetchAll(this.state.page);
    this.observer = new IntersectionObserver(this.handleObserver.bind(this), {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    });
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  getAuthHeaders = () => {
    const token = localStorage.getItem("accesstoken");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  };

  fetchAll = (limit) => {
    this.setState({ loading: true });
    const headers = { headers: this.getAuthHeaders() };

    Promise.all([
      Api.get(
        `users/bookings/upcoming?where={"bookingStatus":"successful"}&relations=[ "bmtEvent" ]&order={ "updatedOn": "DESC"}&limit=${limit}&skip=0`,
        headers
      ),
      Api.get(
        `users/bookings/completed?where={"bookingStatus":"successful"}&relations=[ "bmtEvent" ]&order={ "updatedOn": "DESC"}&limit=${limit}&skip=0`,
        headers
      ),
      Api.get(
        `/users/bookings/failed?relations=[ "bmtEvent" ]&order={ "updatedOn": "DESC"}&limit=${limit}&skip=0`,
        headers
      ),
    ])
      .then(([upcomingRes, completeRes, failedRes]) => {
        this.setState({
          upcoming: upcomingRes.status === 200 ? upcomingRes.data : [],
          complete: completeRes.status === 200 ? completeRes.data : [],
          list: failedRes.status === 200 ? failedRes.data : [],
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleObserver = (entities) => {
    const y = entities[0].boundingClientRect.y;
    if (this.state.prevY > y) {
      const nextPage = this.state.page + 6;
      this.setState({ page: nextPage });
      this.fetchAll(nextPage);
    }
    this.setState({ prevY: y });
  };

  cancelbooking = () => {
    const { cancelBookingId } = this.state;
    if (!cancelBookingId) return;

    this.setState({ loading: true, modalShow2: false });

    Api.patch(`/bookings/${cancelBookingId}/cancelBooking`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem("accesstoken")}` },
    })
      .then(() => {
        this.fetchAll(this.state.page);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  openReview = (item) => {
    this.setState({
      modalShow: true,
      eventid: item.bmtEventId,
      operadtorid: item.operatorId,
      userId: item.userId,
    });
  };

  openCancel = (item) => {
    this.setState({
      modalShow2: true,
      cancelBookingId: item.id,
    });
  };

  getActiveList = () => {
    const { statusB, upcoming, complete, list } = this.state;
    if (statusB === "upcoming") return upcoming;
    if (statusB === "complete") return complete;
    return list;
  };

  render() {
    const { statusB, loading, modalShow, modalShow2 } = this.state;
    const activeList = this.getActiveList();
    const empty = EMPTY_COPY[statusB];

    return (
      <div className="user-bookings">
        <header className="user-bookings__header">
          <h1 className="user-bookings__title">My bookings</h1>
          <p className="user-bookings__subtitle">
            View upcoming trips, past adventures, and booking status.
          </p>
        </header>

        <div className="user-bookings__tabs" role="tablist">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={statusB === tab.key}
              className={`user-bookings__tab ${
                statusB === tab.key ? "user-bookings__tab--active" : ""
              }`}
              onClick={() => this.setState({ statusB: tab.key })}
            >
              {tab.label}
              <span className="user-bookings__tab-count">
                {this.state[tab.listKey]?.length || 0}
              </span>
            </button>
          ))}
        </div>

        {loading && activeList.length === 0 && <Loaders />}

        {!loading && activeList.length === 0 && (
          <div className="user-bookings__empty">
            <h2>{empty.title}</h2>
            <p>{empty.text}</p>
          </div>
        )}

        <Row>
          {activeList.map((item) => (
            <UserBookingCard
              key={item.id}
              item={item}
              tab={statusB}
              onReview={this.openReview}
              onCancel={this.openCancel}
            />
          ))}
        </Row>

        <div
          ref={(el) => {
            this.loadingRef = el;
            if (el && this.observer && !this._observerAttached) {
              this.observer.observe(el);
              this._observerAttached = true;
            }
          }}
          className="user-bookings__infinite-anchor"
          aria-hidden="true"
        />

        {loading && activeList.length > 0 && (
          <p className="user-bookings__loading-more">Loading more…</p>
        )}

        <Modal
          size="md"
          centered
          show={modalShow}
          onHide={() => this.setState({ modalShow: false })}
          dialogClassName="user-bookings-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Write a review</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Review
              eventid={this.state.eventid}
              operadtorid={this.state.operadtorid}
              userId={this.state.userId}
            />
          </Modal.Body>
        </Modal>

        <Modal
          size="md"
          centered
          show={modalShow2}
          onHide={() => this.setState({ modalShow2: false })}
          dialogClassName="user-bookings-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Cancel booking</Modal.Title>
          </Modal.Header>
          <Modal.Body className="user-bookings-modal__body">
            <p className="user-bookings-modal__text">
              Are you sure you want to cancel this booking? This action may be
              subject to the operator&apos;s cancellation policy.
            </p>
            <div className="user-bookings-modal__actions">
              <Button
                variant="outline-secondary"
                onClick={() => this.setState({ modalShow2: false })}
              >
                Keep booking
              </Button>
              <Button
                className="user-bookings-modal__confirm"
                onClick={this.cancelbooking}
              >
                Yes, cancel
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default UserBooking;
